import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveZoneRole from "./retrieveZoneRole";
import * as retrieveRoles from "./retrieveRoles";
import * as retrieveProjectRole from "./retrieveProjectRole";
import * as retrievePlanzoneRole from "./retrievePlanzoneRole";
import * as retrieveProjectsRoles from "./retrieveProjectsRoles";
import * as retrieveAccessRestrictions from "./retrieveAccessRestrictions";
import * as editAccessRestrictions from "./editAccessRestrictions";

const initialState: State = {
  retrieveZoneRole: retrieveZoneRole.initialState,
  retrieveRoles: retrieveRoles.initialState,
  retrieveProjectRole: retrieveProjectRole.initialState,
  retrievePlanzoneRole: retrievePlanzoneRole.initialState,
  retrieveProjectsRoles: retrieveProjectsRoles.initialState,
  retrieveAccessRestrictions: retrieveAccessRestrictions.initialState,
  editAccessRestrictions: editAccessRestrictions.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveZoneRole: retrieveZoneRole.reduceState,
  retrieveRoles: retrieveRoles.reduceState,
  retrieveProjectRole: retrieveProjectRole.reduceState,
  retrievePlanzoneRole: retrievePlanzoneRole.reduceState,
  retrieveProjectsRoles: retrieveProjectsRoles.reduceState,
  retrieveAccessRestrictions: retrieveAccessRestrictions.reduceState,
  editAccessRestrictions: editAccessRestrictions.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveZoneRole.createSelector(() => getState().retrieveZoneRole),
    ...retrieveRoles.createSelector(() => getState().retrieveRoles),
    ...retrieveProjectRole.createSelector(() => getState().retrieveProjectRole),
    ...retrievePlanzoneRole.createSelector(
      () => getState().retrievePlanzoneRole,
    ),
    ...retrieveProjectsRoles.createSelector(
      () => getState().retrieveProjectsRoles,
    ),
    ...retrieveAccessRestrictions.createSelector(
      () => getState().retrieveAccessRestrictions,
    ),
    ...editAccessRestrictions.createSelector(
      () => getState().editAccessRestrictions,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
